import { render, staticRenderFns } from "./ApplicationSent.vue?vue&type=template&id=2c64d81e"
import script from "./ApplicationSent.vue?vue&type=script&lang=js"
export * from "./ApplicationSent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports